<template>
    <div id="productList">
        <template v-for="product in productList.slice(0, productItemNumber)">
            <ProductListItem
                class="override-list-item"
                :product="product"
                :key="product.id"
                @onProductItem="handleProductItem"
            />
        </template>
        <slot/>
        <!-- 分页 -->
        <Pagination
            v-if="hasPagination"
            @changePage="onChangePage"
            :pageSize="pageSize"
            :pageNo="pageNo"
            :totalCount="totalCount"
        />
    </div>
</template>

<script>
import ProductListItem from './ProductListItem'
import Pagination from '@/components/Pagination'
export default {
  props: {
    // 产品列表
    productList: {
      type: Array,
      default: () => []
    },
    // 渲染个数
    productItemNumber: {
      type: Number,
      default: 5
    },
    // 是否有分页组件
    hasPagination: {
      type: Boolean,
      default: true
    },
    pageSize: Number,
    pageNo: Number,
    totalCount: Number
  },
  methods: {
    handleProductItem (product) {
      this.$emit('onProductItem', product)
    },
    onChangePage (pageNo) {
      this.$emit('onChangePage', pageNo)
    }
  },
  components: {
    ProductListItem,
    Pagination
  }
}
</script>

<style lang="scss" scoped>
#productList {
    min-height: 400px;
    position: relative;
}
.override-list-item {
    & /deep/ .range-box {
        padding: 12px 50px 0;
    }
}

.button-wrapper {
    position: absolute;
    top: 0;
    right: -100px;
}
.sticky-button {
    height: 80px;
    width: 80px;
    padding: 0;
    text-align: center;
    line-height: 20px;
    box-shadow: 0px 0px 11px 1px rgba(0, 40, 154, 0.4);
}
.fixed-button {
    position: fixed;
    top: 10px;
}
</style>
